const React = require('react');
const BaseComponent = require('../shared/base');
const client = require('../../../sdk/client');
const $ = require('jquery'); // <-- Añadido: Se asume que usa jQuery

class AddressInformation extends BaseComponent {

    constructor(props){
        super(props);
        this.state = {
            hasError:false,
            hasError2:false,
            firstBool: true,
            secondBool: true,
            wantsBill: false, //por si el usuario quiere factura
            regimenFiscal: '',
            // Si arrAddresses no viene de props, debe estar aquí para que el componente sepa cuándo re-renderizar
            arrAddresses: this.props.arrAddresses || [] 
        };
    }

    updateAddressObject(){
        // Esta lógica usa jQuery y se ejecuta de forma segura en componentDidMount o después.
        var selectedBillingId = $('#billing-addresses').children(':selected').attr('id');
        var selectedExternalBillingId = $('#billing-addresses').children(':selected').attr('billing-address-lider');
        /*var selectedShippingId = "";
        // ... (resto del código comentado de envío) */
        var notes = $('#additional-notes').val();
        var addressObject = {
            selectedBillingId : selectedBillingId,
            selectedExternalBillingId : selectedExternalBillingId,
            additionalNotes : notes
        };
        this.props.callbackAddressInformation(addressObject);
    }

    componentDidMount(){
        var self = this;
        this.getUserAddresses(); // Carga las direcciones y actualiza el estado/props
        
        // Intervalo para régimen fiscal
        this.regimenFiscalInterval = setInterval(() => {
            if(this.props.user.CustomFields) {
                var regimenFiscalField = this.props.user.CustomFields.find(field => field.Code === process.env.CF_REGIMEN_FISCAL);
                let regimenFiscalValue = '';

                if (regimenFiscalField && regimenFiscalField.Values && regimenFiscalField.Values.length > 0) {
                    regimenFiscalValue = regimenFiscalField.Values[0];
                }

                if (this.state.regimenFiscal !== regimenFiscalValue) {
                    this.setState({ regimenFiscal: regimenFiscalValue });
                }
            }
        }, 2000);

        // Select Listener. 
        $('#billing-addresses').on('change', function(){
            self.updateAddressObject();
        });

        // Input listener.
        $('#additional-notes').on('change', function(){
            self.updateAddressObject();
        });

        // First call
        this.updateAddressObject();
        this.setInitialFieldValues();
    }
    
    setInitialFieldValues = () => {
        const { user } = this.props;
    }
    
    componentWillUnmount() {
        clearInterval(this.regimenFiscalInterval);
    }
    
    toggleFactura = () => {
        const { user } = this.props;
        let userRFC = '';
        let userRegimenFiscal = '';

        const rfcField = user.CustomFields.find(field => field.Code === process.env.CF_RFC_EMPRESA);
        if (rfcField && rfcField.Values && rfcField.Values.length > 0) {
            userRFC = rfcField.Values[0];
        }

        const regimenFiscalField = user.CustomFields.find(field => field.Code === process.env.CF_REGIMEN_FISCAL);
        if (regimenFiscalField && regimenFiscalField.Values && regimenFiscalField.Values.length > 0) {
            userRegimenFiscal = regimenFiscalField.Values[0];
        }

        // Condicional para evitar ReferenceError: window is not defined en SSR
        if (typeof window !== 'undefined' && (!userRFC || !userRegimenFiscal)) {
            window.location.href = '/users/settings'; 
        } else {
            this.setState(prevState => ({ 
                wantsBill: !prevState.wantsBill 
            }));
        }
    }

    isB2BUser(customFields) {
        if (!Array.isArray(customFields) || customFields.length === 0) {
            return false;
        }
        for (let field of customFields) {
            if (field.Name === "Tipo de Usuario" && field.Values[0] === "B2B") {
                return true;
            }
            if (field.CustomFields) {
                if (this.isB2BUser(field.CustomFields)) {
                    return true;
                }
            }
        }
        return false;
    }

    // Método enlazado automáticamente con función de flecha
    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }
    
    // Método enlazado automáticamente con función de flecha
    handleAddressChange = () => {
        this.updateAddressObject();
    }

    regimenFiscalOptions(){        
        let output = [
            '601 - General de Ley Personas Morales',        
            '603 - Personas Morales con Fines no Lucrativos',
            '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios',
            '606 - Arrendamiento',
            '607 - Régimen de Enajenación o Adquisición de Bienes',
            '608 - Demás ingresos',
            '610 - Residentes en el Extranjero sin Establecimiento Permanente en México',
            '611 - Régimen de Ingresos por Dividendos (socios y accionistas)',
            '612 - Personas Físicas con Actividades Empresariales y Profesionales',
            '614 - Ingresos por intereses',
            '615 - Régimen de los ingresos por obtención de premios',
            '616 - Sin obligaciones fiscales',
            '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
            '621 - Incorporación Fiscal',
            '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
            '623 - Opcional para Grupos de Sociedades',
            '624 - Coordinados',
            '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
            '626 - Régimen Simplificado de Confianza'
        ];
        return output;
    }

    renderAddressesOptions() {
        let arrOptions = [];
        const addresses = this.state.arrAddresses || this.props.arrAddresses;
        var self = this;

        // Se usa el estado o los props para renderizar de forma declarativa
        if (addresses && addresses.length > 0) {
            addresses.forEach(function(address, index) {
                if (!address.Pickup) {
                    var addressName = address.Line2 || address.Name;
                    var isSelected = self.props.selectedAddressWidget === address.ID; 
                    arrOptions.push(
                        <option
                            key={index}
                            id={address.ID}
                            billing-address-lider={address.SpecialInstructions}
                            value={address.ID}
                            selected={isSelected}>
                            {addressName}
                        </option>
                    );
                }
            });
        }
        
        // Si hay opciones, las devolvemos en un <select>
        if (arrOptions.length > 0) {
            return (
                <select id="billing-addresses" onChange={this.handleAddressChange}>
                    {arrOptions}
                </select>
            );
        }
        
        // Si no hay direcciones, se muestra la opción de redirigir.
        return (
            <select id="billing-addresses" onClick={this.redirectToSettings}>
                <option>Click aquí para añadir una dirección desde tu perfil</option>
            </select>
        );
    }


    redirectToSettings = () => {
        if (typeof window !== 'undefined') {
            window.location.href = '/users/settings';
        } 
    }

    getUserAddresses(){
        var self = this;
        client.Addresses.getUserAddresses(this.props.user.ID, function(err, addresses){
            if (addresses && addresses.Records && addresses.Records.length > 0) {
                // Se actualiza el estado para que renderAddressesOptions se ejecute con los datos.
                self.setState({ "arrAddresses" : addresses.Records }, () => {
                    self.updateAddressObject();
                });
            } else {
                console.log("No addresses found");
            }
        });
    }

    // Solución 2: Usar sintaxis de flecha para eliminar .bind(this)
    onChange = (event) => {
        var abc = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
        var abcT = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
        var num = ['0','1','2','3','4','5','6','7','8','9', ' '];
        //var sym = ['+','-','%','$',',','.', 'á', 'é', 'í', 'ó', 'ú', ' '];
        
        var output = event.target.value.split('');
        var newStr = "";

        for (var index in output) {
            var letter = output[index];
            if(abc.includes(letter) || abcT.includes(letter) || num.includes(letter)) { //|| sym.includes(letter)) {
                //ignore
            } else {
                newStr = newStr + letter;
            }
        }

        if(newStr.length > 0){
            this.setState({ hasError: true });
            this.setState({ firstBool: false });
            this.props.updateBoolProp(false, this.state.secondBool);
        } else {
            this.setState({ hasError: false });
            this.setState({ firstBool: true });
            this.props.updateBoolProp(true, this.state.secondBool);
        }
    }

    // Solución 2: Usar sintaxis de flecha para eliminar .bind(this)
    onChange2 = (event) => {
        var abc = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
        var abcT = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
        var num = ['0','1','2','3','4','5','6','7','8','9', ' '];
        //var sym = ['+','-','%','$',',','.', 'á', 'é', 'í', 'ó', 'ú', ' '];

        var output = event.target.value.split('');
        var newStr = "";

        for (var index in output) {
            var letter = output[index];
            if(abc.includes(letter) || abcT.includes(letter) || num.includes(letter)) { //|| sym.includes(letter)) {
                //ignore
            } else {
                newStr = newStr + letter;
            }
        }

        if(newStr.length > 0){
            this.setState({ hasError2: true });
            this.setState({ secondBool: false });
            this.props.updateBoolProp(this.state.firstBool, false);
        } else {
            this.setState({ hasError2: false });
            this.setState({ secondBool: true });
            this.props.updateBoolProp(this.state.firstBool, true);
        }
    }

    render(){
        const { user } = this.props;
        let regimenFiscalOptions = this.regimenFiscalOptions();
        let userRFC = '';
        if (user && user.CustomFields) {
            const rfcField = user.CustomFields.find(field => field.Code === process.env.CF_RFC_EMPRESA);
            if (rfcField && rfcField.Values && rfcField.Values.length > 0) {
                userRFC = rfcField.Values[0];
            }
        }
        // Check if user is B2B
        const isB2B = this.isB2BUser(user.CustomFields);

        // BLOQUE ELIMINADO: La manipulación directa del DOM (document.getElementById) 
        // y la llamada a client.Addresses.getUserAddresses() fueron eliminadas de render().

        return(
            <div className="address-container">
                <div className="address-box">
                    <div>
                        <label>Nombre(s)</label>
                        <input type="text"  value={this.props.user.FirstName} readOnly></input>
                    </div>
                    <div>
                        <label>Apellidos</label>
                        <input type="text" value={this.props.user.LastName} readOnly></input>
                    </div>
                </div>
                <div className="address-box">
                    <div>
                        <label>Número de contacto</label>
                        <input type="text" value={this.props.user.PhoneNumber} readOnly></input>
                    </div>
                    <div>
                        <label>Correo</label>
                        <input type="text" value={this.props.user.Email} readOnly></input>
                    </div>
                </div>
                <div className="address-box bp-grid">
                    <div>
                        <p>Dirección de facturación</p>
                        
                        {/* Renderiza el select usando el método declarativo */}
                        {this.renderAddressesOptions()} 
                        
                        {!isB2B && (
                            <label>
                                <input
                                    id="billing-required"
                                    type="checkbox"
                                    checked={this.state.wantsBill}
                                    onChange={this.toggleFactura}
                                />
                                ¿Requiere factura?
                            </label>
                        )}
                    </div>
                    {this.state.wantsBill && (
                        <div>
                            <div>
                                <label>
                                    Régimen Fiscal
                                    <select 
                                        name="regimenFiscal" 
                                        value={this.state.regimenFiscal}
                                        onChange={this.handleInputChange}
                                    >
                                        <option value="">Seleccione una opción</option>
                                        {regimenFiscalOptions.map((option, index) => (
                                            <option key={index} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                            <div>
                                <label style={{marginTop: '1rem'}}> 
                                    RFC
                                    <input
                                        type="text"
                                        name="rfc"
                                        value={userRFC}
                                        onChange={this.handleInputChange}
                                        />
                                </label>
                            </div>
                        </div>
                    )}
                    <div className="hide">
                        <div>
                            <label className="padding-top">Dirección de envío</label>
                            <div className="flex">
                                <input id="chk-same-as-billing" type="checkbox"></input>
                                <label>La misma que la de facturación</label>                           
                            </div>
                        </div>
                        <div id="same-as-billing">
                            <label>Dirección</label>
                            <select id="shipping-addresses">
                            </select>
                        </div>
                    </div>
                    <div>
                        <label className="padding-top">Notas adicionales</label>
                        {/* Solución 2: Llama a onChange sin .bind(this) */}
                        <input onChange={this.onChange} id="additional-notes" type="text" defaultValue=""></input>
                        {this.state.hasError && <span><label style={{color: "red",fontWeight: "700"}}>Este campo solo acepta números y letras</label></span>} 
                    </div>
                </div>
                <div className="address-box" style={{paddingTop:"0px"}}>
                    <div>
                        <label style={{marginTop:"6px"}}>Folio o Referencia</label>
                        {/* Solución 2: Llama a onChange2 sin .bind(this) */}
                        <input onChange={this.onChange2} type="text" id="txt-folio" defaultValue=""></input>
                        {this.state.hasError2 && <span><label style={{color: "red",fontWeight: "700"}}>Este campo solo acepta números y letras</label></span>} 
                    </div>
                    <div id="container-CFDI">
                        <label id="lbl-CFDI"style={{marginTop:"0px", height:"0px"}}>Uso del CFDI</label>
                        <select id="selected-cfdi">
                            <option value="G01">G01 - Adquisición de mercancías</option>
                            <option value="G03">G03 - Gastos en general</option>
                            <option value="I08">I08 - Otra maquinaria y equipo</option>
                            <option value="P01">P01 - Por definir</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}
module.exports = AddressInformation;